import { render, staticRenderFns } from "./superganho.vue?vue&type=template&id=f09a3e14"
import script from "./superganho.vue?vue&type=script&lang=js"
export * from "./superganho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports